const CurvedLine = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path stroke="currentColor" d="M5 17c4 0 5-9 9-9s5 9 9 9"/>
        </svg>
}

export default CurvedLine
